module.exports = __webpack_public_path__ + "img/right-arrow.40420edb.svg";